<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div style="display: flex; justify-content: space-between">
          <button class="btn btn-primary" @click="showAddModal">Создать продажу</button>
        </div>
        <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
          <div v-if="this.isLoading">
            <CircleProgress/>
          </div>
        </transition>
        <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
          <div v-if="!this.isLoading">
            <Table
                :isArenda="false"
                :availableEdit="false"
                :columns="columns"
                :data="orders"
                :editAction="showEditModal"
                :deleteAction="deleteClient"
                :updateClients="fullUpdate"
                :tableName="'Продажи'"
                :products="products"
                :clients="clients"
                :isDoc="true"
                :count="count"
            />
            <div style="display: flex; justify-content: flex-end; margin-top: 10px;">
              <button class="btn btn-primary" style="margin-right: 10px;" @click="previousPage"
                      :disabled="orderPaginationStart <= 1"><i
                  class="ni ni-bold-left"></i></button>
              <button class="btn btn-primary" @click="nextPage" :disabled="orderListSize > orders.length"><i
                  class="ni ni-bold-right"></i></button>
            </div>
          </div>
        </transition>
      </div>
      <ClientCreateModal :createClient="fetchClient"/>
      <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
        <div v-if="showModal">
          <div class="modal" :class="{ 'd-block': showModal }" id="productModal" tabindex="-2" role="dialog"
               aria-labelledby="productModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document" style="maxWidth: 750px; margin-left: 280px;">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="productModalLabel">{{
                      this.orderIsEditable ? 'Редактировать' : 'Создать'
                    }}
                    Продажу</h5>
                  <b-button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                    <span aria-hidden="true">&times;</span>
                  </b-button>
                </div>
                <div class="modal-body">
                  <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
                    <div v-if="this.orderDataIsLoading">
                      <CircleProgress/>
                    </div>
                  </transition>
                  <div v-if="!orderDataIsLoading">

                    <h6>Продажа</h6>
                    <div class="order-block">

                      <div style="display: flex; align-items: center; max-width: 310px; width: 100%;">
                        <div class="input-container" style="position: relative; max-width: 300px; width: 100%;">
                          <label for="client">Клиент</label>
                          <input
                              id="client"
                              v-model="clientFilterStr"
                              type="text"
                              placeholder="Введите имя клиента для поиска"
                              style="max-width: 100%; border: 1px solid #d2d6da; color: #495057; border-radius: 0.5rem; font-size: 0.85rem; padding: 0.5rem 0.75rem;"
                              @input="filterClients"
                              @focus="showOptions = true"
                              @blur="onBlurHandler"
                          >
                          <ul v-if="showOptions" class="options-list">
                            <li @click="updateClientShowModal(true)">
                              Создать клиента
                            </li>
                            <li
                                v-for="(client) in filteredClients"
                                :key="client.id"
                                @click="setOrderClient(client)"
                            >
                              {{ client.fullName }}
                            </li>
                          </ul>
                        </div>
                        <a v-if="this.client != null" style="margin-left: 15px; margin-top: 21px;" href="javascript:;" @click="blockClient(client)">
                          <i class="fas fa-ban text-warning"></i>
                        </a>
                      </div>

                    </div>


                    <argon-button
                        variant="fill"
                        color="primary"
                        style="margin-top: 16px;"
                        full-width
                        :disabled="addProductModal"
                        @click="openOrderAddProductModal"
                        type="button"
                    >
                      Добавить товары
                    </argon-button>

                    <table class="products-preview">
                      <thead>
                      <tr>
                        <th>Продукт</th>
                        <th>Количество</th>
                        <th>Скидка</th>
                        <th>Цена</th>
                        <th>Цена со скидкой</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in productOrderItems" :key="index">
                        <td>{{ getProductNameById(item.productId) }}</td>
                        <td>{{ item.quantity }}</td>
                        <td v-if="!this.orderIsEditable">
                          <input class="order-discount" v-if="!this.orderIsEditable" type="number"
                                 v-model="item.discount"
                                 min="0" max="100"><input class="order-discount" v-else @focusin="toggleReadonly"
                                                          @focusout="toggleReadonly" v-model="item.discount">%
                        </td>
                        <td v-else>
                          {{ item.discount }}%
                        </td>
                        <td>{{ getPriceWithoutDiscount(item.productId, item.quantity) }} BYN</td>
                        <td>{{ getTotalPrice(item.productId, item.quantity, item.discount) }} BYN</td>
                        <td>
                          <a href="javascript:;" @click="removeProductFromOrder(index)">
                            <i class="fas fa-trash "></i>
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <div v-if="this.orderIsEditable">
                      <div class="sub-total" v-if="this.deposit != 0 ">
                        <argon-button
                            variant="fill"
                            color="primary"
                            style="font-size: 0.7rem; padding: 7px;"
                            @click="generateDopSogl"
                            type="button"
                        >
                          Доп соглашение
                        </argon-button>
                      </div>
                    </div>

                    <div style="margin-top: 16px;" v-if="productOrderItems.length != 0">ИТОГО:
                      {{ getOrderTotalPriceWithoutDiscount() }}
                      BYN
                    </div>
                    <div style="margin-top: 16px;" v-if="productOrderItems.length != 0">С УЧЕТОМ СКИДКИ:
                      {{ getOrderTotalPrice() }}
                      BYN
                    </div>

                    <label for="orderDiscount"
                           style="font-weight: bold; margin-top: 16px;">Скидка</label>
                    <div class="row-input">
                      <argon-input
                          style="max-width: 140px;"
                          id="orderDiscount"
                          placeholder="Скидка"
                          type="number"
                          v-model="orderDiscount"
                          :value="orderDiscount"
                          @input="setCustomDiscount"
                          min="0"
                          max="100"
                      />
                      <argon-button
                          variant="fill"
                          color="primary"
                          type="submit"
                          style="margin-left: 25px;"
                          @click="recalulateDiscount"
                      > Применить
                      </argon-button>

                    </div>

                    <div v-if="!this.orderIsEditable" class="form-nav-buttons">
                      <argon-button
                          variant="fill"
                          color="primary"
                          type="submit"
                          style="margin-top: 5px;"
                          @click="createOrder"
                          :disabled="!checkCreateOrder()"
                      >Создать
                      </argon-button>
                    </div>
                    <div v-if="this.orderIsEditable" class="form-nav-buttons">
                      <argon-button
                          variant="fill"
                          color="primary"
                          type="submit"
                          style="margin-top: 5px;"
                          @click="editOrder"
                          :disabled="!checkCreateOrder()"
                      >Сохранить
                      </argon-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
              <div v-if="addProductModal">
                <div class="modal-product" :class="{ 'd-block': addProductModal }" id="productModal" tabindex="-1"
                     role="dialog"
                     aria-labelledby="productModalLabel" aria-hidden="true">
                  <div class="" role="document">
                    <div class="modal-content"
                         style="border-top-left-radius: 0; border-bottom-left-radius: 0; border-left: none">
                      <div class="modal-body">
                        <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
                          <div v-if="this.orderDataIsLoading">
                            <CircleProgress/>
                          </div>
                        </transition>
                        <div v-if="!orderDataIsLoading">
                          <div style="display: flex; justify-content: space-between">
                            <div
                                style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
                              <h6>Доступные товары</h6>
                              <argon-input
                                  id="searchField"
                                  placeholder="Поиск"
                                  v-model="addProductSearchStr"
                                  :value="addProductSearchStr"
                                  style="margin-right: 10px;"
                                  @input="searchProducts"

                              />
                            </div>
                            <b-button type="button" class="close" data-dismiss="modal" aria-label="Close"
                                      @click="closeOrderAddProductModal">
                              <span aria-hidden="true">&times;</span>
                            </b-button>
                          </div>
                          <div class="table-container">
                            <table class="products-preview">
                              <thead>
                              <tr>
                                <th>Продукт</th>
                                <th>Цена за единицу</th>
                                <th>Доступное количество</th>
                                <th>Количество</th>
                                <th></th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="(item, index) in activeFilteredProducts" :key="index">
                                <td>{{ item.name }}</td>
                                <td style="font-weight: bold">{{ item.equipmentCost }} BYN</td>
                                <td style="font-weight: bold;">{{ availableCountProducts[item.id] }}</td>
                                <td><input type="number" min="0" :max="this.availableCountProducts[index]"
                                           style="max-width: 40px; width: 100%;"
                                           v-model="countControllers[index]"
                                           @input="updateProductCount(index, $event.target.value)"
                                ></td>
                                <td>
                                  <argon-button
                                      variant="fill"
                                      color="primary"
                                      style="font-size: 0.7rem; padding: 7px;"
                                      :disabled="this.countControllers[index] > this.availableCountProducts[index] || this.countControllers[index] <= 0"
                                      @click="addProductToOrder(index, item)"
                                      type="button"
                                  >
                                    Добавить
                                  </argon-button>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <!--  МОДАЛКА ТОВАРОВ-->
        </div>
      </transition>
    </div>
  </div>
</template>


<script>
import CircleProgress from "./components/CircleProgress.vue";
//import Table from "./components/Table.vue";
import axios from "@/axios";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import ArgonButton from "@/components/ArgonButton.vue";
import velocity from "velocity-animate";
import ArgonInput from "../components/ArgonInput.vue";
import Table from "./components/Table.vue";
import ClientCreateModal from "./components/ClientCreation/ClientCreationModal.vue";

export default {
  name: "ClientsTable",
  components: {
    ClientCreateModal,
    Table,
    ArgonInput,
    ArgonButton,
    CircleProgress
  },
  data() {
    return {
      searchQuery: '',
      showOptions: false,
      clients: [],
      products: [],
      activeProducts: [],
      activeFilteredProducts: [],
      productCounts: [],
      orders: [],
      count: 0,
      columns: ['ID', 'Клиент', 'Дата покупки', 'Юр. лицо', 'Товары'],
      editingProduct: null,
      formErrors: {
        name: false,
        equipmentCost: false,
        qty: false
      },
    };
  },
  computed: {
    //START

    filteredClients() {
      if (!this.clientFilterStr || this.clientFilterStr.trim() === '') {
        return this.clients.filter((client) => client.blackList == null);
      } else {
        return this.clients.filter((client) =>
            client.fullName.toLowerCase().includes(this.clientFilterStr.toLowerCase()) && client.blackList == null
        );
      }
    },

    addProductSearchStr: {
      get() {
        return this.$store.state.addProductSearchStr;
      },
    },

    orderInstallation: {
      get() {
        return this.$store.state.orderInstallation;
      },
    },
    orderPaidFor: {
      get() {
        return this.$store.state.orderPaidFor;
      },
    },
    orderShipment: {
      get() {
        return this.$store.state.orderShipment;
      }
    },
    orderAssembly: {
      get() {
        return this.$store.state.orderAssembly;
      }
    },
    availableCountProducts: {
      get() {
        return this.$store.state.availableCountProducts;
      },
    },
    countControllers: {
      get() {
        return this.$store.state.countControllers;
      },
    },
    addProductModal: {
      get() {
        return this.$store.state.orderProductModal;
      },
    },
    deposit: {
      get() {
        return this.$store.state.orderDeposit;
      },
    },

    orderIsEditable: {
      get() {
        return this.$store.state.orderEditable;
      },
    },
    isLoading: {
      get() {
        return this.$store.state.isOrderDataLoading;
      },
    },

    showModal: {
      get() {
        return this.$store.state.orderModal
      }
    },

    showClientModal: {
      get() {
        return this.$store.state.clientShowModal
      }
    },

    orderDataIsLoading: {
      get() {
        return this.$store.state.orderDataIsLoading
      }
    },

    orderStatus: {
      get() {
        return this.$store.state.createOrderStatus
      }
    },
    filterStatusId: {
      get() {
        return this.$store.state.filterOrderByStatusId
      }
    },
    searchOrderName: {
      get() {
        return this.$store.state.searchOrderName
      }
    },
    filterOrderByDate: {
      get() {
        return this.$store.state.filterOrderByDate
      }
    },
    filterOrderByDateStart: {
      get() {
        return this.$store.state.filterOrderByDateStart
      }
    },
    client: {
      get() {
        return this.$store.state.createOrderClient
      }
    },
    clientFilterStr: {
      get() {
        return this.$store.state.clientFilterStr
      }
    },
    product: {
      get() {
        return this.$store.state.createOrderProduct
      }
    },
    singlePrice: {
      get() {
        return this.$store.state.createOderSingleProductPrice
      }
    },
    productCount: {
      get() {
        return this.$store.state.createOrderProductCount
      }
    },
    selectedProductCount: {
      get() {
        return this.$store.state.createOrderSelectedCount
      }
    },
    singleOrderTotalPrice: {
      get() {
        return this.$store.state.createSingleOrderTotalPrice
      }
    },
    createOrderFrom: {
      get() {
        return this.$store.state.createOrderFrom
      }
    },
    createOrderTo: {
      get() {
        return this.$store.state.createOrderTo
      }
    },
    orderDiscount: {
      get() {
        return this.$store.state.createOrderDiscount
      }
    },
    dayDifference: {
      get() {
        return this.$store.state.createOrderDayDifference
      }
    },
    productOrderItems: {
      get() {
        return this.$store.state.createOrderItems
      }
    },
    promo: {
      get() {
        return this.$store.state.createOrderPromo
      }
    },
    orderId: {
      get() {
        return this.$store.state.updateOrderId
      }
    },
    orderListSize: {
      get() {
        return this.$store.state.orderListSize
      }
    },
    orderPaginationStart: {
      get() {
        return this.$store.state.orderPaginationStart
      }
    },

  },
  methods: {

    searchProducts(payload) {
      this.$store.commit('updateAddProductSearchStr', payload.target.value);
      this.activeFilteredProducts = this.activeProducts.filter(product =>
          product.name.toLowerCase().includes(this.addProductSearchStr.toLowerCase())
      );

      let indices = this.activeFilteredProducts.map(filteredProduct => filteredProduct.id);
      const newCounts = indices.reduce((acc, id) => {
        acc[id] = this.productCounts[id];
        return acc;
      }, {});
      this.$store.commit('updateAvailableCountProducts', newCounts);
    },


    getDaysDifference(date1, date2) {
      const d1 = new Date(date1);
      const d2 = new Date(date2);

      const diffInMilliseconds = Math.abs(d2 - d1);
      const diffInDays = Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24));

      return diffInDays;
    },

    onBlurHandler() {
      setTimeout(() => {
        this.showOptions = false;
      }, 200);
    },

    filterClients(payload) {
      this.$store.commit('updateClientFilterStr', payload.target.value);
      this.showOptions = true;
    },

    updateProductCount(index, value) {
      let newControllers = this.countControllers;
      newControllers[index] = Number(value);
      this.$store.commit('updateCountControllers', newControllers);
    },

    recalulateDiscount() {
      let newProductOrderItems = this.productOrderItems.map(item => {
        item.discount = this.orderDiscount
        return item;
      });
      this.setCreateProductItems(newProductOrderItems);
    },

    deleteAvailableCounts(index, productId) {
      let newControllers = {...this.availableCountProducts};
      newControllers[productId] = newControllers[productId] - this.countControllers[index];
      this.productCounts[productId] = newControllers[productId];
      this.$store.commit('updateAvailableCountProducts', newControllers);
    },

    addAvailableCounts(index, value, productId) {
      let newControllers = {...this.availableCountProducts};
      newControllers[productId] = newControllers[productId] + value;
      this.productCounts[productId] = newControllers[productId];
      this.$store.commit('updateAvailableCountProducts', newControllers);
    },

    createCountControllers() {
      const controllers = this.activeProducts.map(() => 0);
      this.$store.commit('updateCountControllers', controllers);
    },

    createAvailableProductCounts() {
      const controllers = this.activeProducts.reduce((acc, product) => {
        acc[product.id] = product.dostupno
        return acc;
      }, {});
      this.productCounts = controllers;
      console.log("CONTROLLERS: ", controllers);
      this.$store.commit('updateAvailableCountProducts', controllers);
    },
    toggleReadonly(event) {
      event.preventDefault();
      if (event.target.getAttribute('readonly') == 'readonly') {
        event.target.removeAttribute('readonly');
      } else {
        event.target.setAttribute('readonly', 'readonly');
      }
    },

    createOrder() {
      this.setIsLoading(true);
      const order = {
        // status: this.orderStatus,
        clientId: this.client,
        paymentAmount: this.getOrderTotalPriceWithoutDiscount(),
        endPrice: this.getOrderTotalPrice(),
        discount: this.orderDiscount,
        orderItems: this.productOrderItems,
        isArenda: false
      }
      axios.post('/api/order/new', order).then(() => {
        this.clearOrderFields();
        this.fetchData();
        this.fetchProducts();
        this.setIsLoading(false);
        this.setOrderModal(false);
        this.closeOrderAddProductModal();
      });
    },

    editOrder() {
      const order = {
        status: this.orderStatus,
        clientId: this.client,
        paymentAmount: this.getOrderTotalPriceWithoutDiscount(),
        endPrice: this.getOrderTotalPrice(),
        discount: this.orderDiscount,
        securityDepositAmount: this.deposit,
        rentStartDate: this.createOrderFrom,
        rentEndDate: this.createOrderTo,
        sborka: this.orderAssembly,
        ustanovka: this.orderInstallation,
        orderItems: this.productOrderItems,
        delivery: this.orderShipment,
        oplacheno: this.orderPaidFor,
        isArenda: true
      }
      this.setIsLoading(true);
      axios.put(`/api/order/${this.orderId}/update`, order).then(() => {
        this.clearOrderFields();
        this.fetchData();
        this.fetchProducts();
        this.setIsLoading(false);
        this.setOrderModal(false);
      });
    },
    checkAddOrder() {
      if (this.dayDifference > 0) {
        return this.product !== null &&
            this.selectedProductCount !== null &&
            this.createOrderFrom != null &&
            this.createOrderTo != null;
      }
      return false;
    },
    checkCreateOrder() {
      return this.client !== null &&
          this.productOrderItems.length != 0
    },
    addProductToOrder(index, item) {
      let existingOrderItem = this.productOrderItems.find(orderItem => orderItem.productId === item.id);

      if (existingOrderItem) {
        existingOrderItem.quantity += this.countControllers[index];
      } else {
        const orderItem = {
          productId: item.id,
          quantity: this.countControllers[index],
          discount: this.orderDiscount,
        }
        this.productOrderItems.push(orderItem);
      }

      const deposit = item.equipmentCost * this.countControllers[index];
      this.$store.commit('updateOrderDeposit', deposit + this.deposit);
      this.setCreateProductItems(this.productOrderItems);
      this.clearSingleProduct();
      this.deleteAvailableCounts(index, item.id);
      this.updateProductCount(index, 0);
    },
    getProductNameById(id) {
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id == id) {
          return this.products[i].name;
        }
      }
      return 'Продукт не найден';
    },
    getTotalPrice(id, count, discount) {
      const price = this.getProductPriceById(id);
      let totalPrice = count * price;
      if (discount !== 0) {
        totalPrice = totalPrice * (1 - discount / 100);
      }
      totalPrice = totalPrice.toFixed(2);
      return totalPrice;

    },
    getPriceWithoutDiscount(id, count) {
      const price = this.getProductPriceById(id);
      console.log("TOTAL SALES: " + price);
      let totalPrice = count * price;
      totalPrice = totalPrice.toFixed(2);
      return totalPrice;

    },
    getProductPriceById(id) {
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id == id) {
          return this.products[i].equipmentCost;
        }
      }
      return 0;
    },

    getProductCountById(id) {
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id == id) {
          return this.products[i].equipmentCost;
        }
      }
      return 0;
    },
    blockClient(id) {
      if (confirm("Вы уверены, что хотите внести клиента в черный список?")) {
        const reason = prompt("Пожалуйста, введите причину:");
        this.addToBlacklist(id, reason);
      }
    },

    addToBlacklist(id, reason) {
      axios.post('/api/clients/add-to-blacklist/'+ id, {reason: reason}).then(() => {
        this.$store.commit('updateCreateOrderClient', null);
        this.$store.commit('updateClientFilterStr', null);
      });
    },
    setDocIsLoading(active) {
      this.$store.commit('updateIsDocLoading', active);
    },
    generateDopSogl() {
      const orderId = this.orderId;
      this.setDocIsLoading(true);

      axios
          .get(`/api/order/${orderId}/generate-legal-dop-sogl`, {
            responseType: 'blob',
          })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'dop_soglashenie' + orderId + '.docx');

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch((error) => {
            console.error('Error generating legal contract:', error);
          });
      this.setDocIsLoading(false);
    },
    getOrderTotalPriceWithoutDiscount() {
      let totalPrice = 0;
      for (let i = 0; i < this.productOrderItems.length; i++) {
        totalPrice += Number(this.getPriceWithoutDiscount(this.productOrderItems[i].productId, this.productOrderItems[i].quantity));
      }
      return totalPrice.toFixed(2);
    },
    getOrderTotalPrice() {
      let totalPrice = 0;
      for (let i = 0; i < this.productOrderItems.length; i++) {
        totalPrice += Number(this.getTotalPrice(this.productOrderItems[i].productId, this.productOrderItems[i].quantity, this.productOrderItems[i].discount));
      }
      return totalPrice.toFixed(2);
    },
    removeProductFromOrder(index) {
      this.addAvailableCounts(index, this.productOrderItems[index].quantity, this.productOrderItems[index].productId);
      this.productOrderItems.splice(index, 1);
      this.setCreateProductItems(this.productOrderItems);
    },
    setProductData(product) {
      this.setSingleOrderTotalPrice(0);
      this.setOrderProduct(product);
      const singlePrice = this.getEquipmentCostById(Number(product.target.value));
      this.setSinglePrice(singlePrice);
      const count = this.getAvailableCountProducts(Number(product.target.value));
      this.setProductCount(count);
    },


    calulateSingleTotalPrice() {
      let newTotalPrice = this.selectedProductCount * this.singlePrice;
      if (this.orderDiscount !== 0) {
        newTotalPrice = newTotalPrice * (1 - this.orderDiscount / 100);
      }
      newTotalPrice = newTotalPrice.toFixed(2);
      this.setSingleOrderTotalPrice(newTotalPrice);
    },

    getSingleTotalPrice() {
      let newTotalPrice = this.selectedProductCount * this.singlePrice;
      if (this.orderDiscount !== 0) {
        newTotalPrice = newTotalPrice * (1 - this.orderDiscount / 100);
      }
      newTotalPrice = newTotalPrice.toFixed(2);
      this.setSingleOrderTotalPrice(newTotalPrice);
      return newTotalPrice;
    },

    selectCountProduct(count) {
      this.setSelectedProductCount(count.target.value);
      this.calulateSingleTotalPrice();
    },

    getEquipmentCostById(id) {
      const item = this.products.find(item => item.id === id);
      return item ? item.equipmentCost : null;
    },

    getAvailableCountProducts(id) {
      const item = this.products.find(item => item.id === id);
      return item ? item.qty - item.active - item.bron : 0;
    },

    fetchData() {
      this.setIsLoading(true);
      let url = '/api/order/orders?page=' + this.orderPaginationStart + '&perPage=' + this.orderListSize + "&type=0";
      axios.get(url).then(response => {
        let orders = response.data.orders.map(order => {
          let clientIdIndex = Object.keys(order).indexOf('clientId');

          let newOrder = {...order};
          let keys = Object.keys(newOrder);
          let values = Object.values(newOrder);

          keys.splice(clientIdIndex + 1, 0, 'clientStatus');
          values.splice(clientIdIndex + 1, 0, order.clientId);

          let updatedOrder = {};
          keys.forEach((key, i) => {
            updatedOrder[key] = values[i];
          });

          return updatedOrder;
        });
        orders.forEach(order => {
          delete order.isArenda;
        });

        this.count = response.data.count;

        orders = orders.map(order => {
          return {
            id: order.id,
            clientId: order.clientId,
            rentStartDate: order.rentStartDate,
            clientStatus: order.clientStatus,
            paymentAmount: order.paymentAmount,
            discount: order.discount,
            endPrice: order.endPrice,
            orderItems: order.orderItems
          };
        });

        console.log("FILTERED ORDERS: ", orders);
        this.orders = orders;
        this.setIsLoading(false);
      }).catch(error => {
        console.error("Ошибка загрузки данных: ", error);
        this.setIsLoading(false);
      });
    },

    fetchClient() {
      const url = '/api/clients?length=10000'
      this.clearSearchText();
      // if (this.clientPaginationStart != 0) {
      //   this.resetPagination();
      // }
      axios.get(url).then(response => {
        this.clients = response.data;
        this.updateClientIsLoading(false);
      }).catch(error => {
        console.error("Ошибка загрузки данных: ", error);
      });
    },
    fetchProducts() {
      let url = '/api/product?length=10000';
      axios.get(url).then(response => {
        this.activeProducts = response.data.filter(product => product.dostupno > 0);
        this.activeFilteredProducts = this.activeProducts;
        this.products = response.data;
        this.createCountControllers();
        this.createAvailableProductCounts();
      }).catch(error => {
        console.error("Ошибка загрузки данных: ", error);
      });
    },
    fetchPassportAuthors() {
      axios.get('/api/clients/pasport_autors').then(response => {
        this.passportAuthors = response.data;
      }).catch(error => {
        console.error("Ошибка загрузки данных: ", error);
      });
    },
    getClientNameById(id) {
      for (let i = 0; i < this.clients.length; i++) {
        if (this.clients[i].id == id) {
          return this.clients[i].fullName;
        }
      }
      return 'Клиент не найден';
    },

    deleteClient(order) {
      this.setIsLoading(true);
      axios.delete(`/api/order/${order.id}`).then(() => {
        this.fetchData();
        this.fetchProducts();
      });
      this.setIsLoading(false);
    },
    showAddModal() {
      this.updateOrderDataIsLoading(true);
      this.setOrderModal(true);
      this.updateOrderDataIsLoading(false);
    },
    showEditModal(order) {
      this.setIsLoading(true);
      const clientName = this.getClientNameById(order.clientId);
      this.$store.commit('updateClientFilterStr', clientName);

      this.setOrderIsEditable(true);
      this.setOrderData(order);
      this.setOrderModal(true);

      this.setIsLoading(false);
    },
    validateForm() {
      this.formErrors.name = !this.productData.name;
      this.formErrors.equipmentCost = !this.productData.equipmentCost;
      this.formErrors.qty = !this.productData.qty || this.productData.qty <= 0;

      return !(this.formErrors.name || this.formErrors.equipmentCost || this.formErrors.qty);
    },
    previousStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },
    resetCreationSteps() {
      this.currentStep = 1;
    },
    setCustomDiscount(customDiscount) {
      this.setOrderDiscount(Number(customDiscount.target.value));
    },

    openOrderAddProductModal() {
      this.$store.commit('updateOrderProductModal', true);
      // this.$store.commit('updateCountControllers', this.productCounts);
    },

    closeOrderAddProductModal() {
      this.$store.commit('updateOrderProductModal', false);
      this.$store.commit('updateAddProductSearchStr', "");
      this.$store.commit('updateAvailableCountProducts', this.productCounts);
      this.activeFilteredProducts = this.activeProducts;
    },

    clearClientData() {
      this.$store.commit('clearCreateClient');
    },
    updateClientIsLoading(active) {
      this.$store.commit('updateClientIsLoading', active);
    },
    updateClientRequestIsLoading(active) {
      this.$store.commit('updateClientRequestIsLoading', active);
    },
    updateOrderPaidFor(sum) {
      let value = sum.target.value;
      if (value === '' || !isNaN(value)) {
        this.$store.commit('updateOrderPaidFor', value);
      }

    },
    updateClientShowModal(active) {
      this.showOptions = false;
      this.$store.commit('updateClientShowModal', active);
    },

    closeModal() {
      this.setOrderModal(false);
      this.clearOrderFields();
      this.setOrderIsEditable(false);
      this.$store.commit('updateClientFilterStr', null);
    },
    setOrderData(clientData) {
      this.$store.commit('setUpdateOrderData', clientData);
    },
    setOrderIsEditable(isEditable) {
      this.$store.commit('updateOrderEditable', isEditable);
    },
    setSearchText(payload) {
      this.$store.commit('updateClientSearchText', payload.target.value);
    },
    setSearchOrderText(payload) {
      this.$store.commit('updateSearchOrderName', payload.target.value);
    },
    clearSearchText() {
      this.$store.commit('updateClientSearchText', null);
    },
    nextPage() {
      const currentStep = this.orderPaginationStart + 1;
      this.$store.commit('updateOrderPaginationStart', currentStep);
      this.setIsLoading(true);
      this.fetchData();
      this.setIsLoading(false);
    },
    previousPage() {
      const currentStep = this.orderPaginationStart - 1;
      this.$store.commit('updateOrderPaginationStart', currentStep);
      this.setIsLoading(true);
      this.fetchData();
      this.setIsLoading(false);
    },
    resetPagination() {
      this.$store.commit('updateClientPaginationStart', 0);
    },

    setOrderModal(active) {
      this.$store.commit('updateOrderModal', active);
    },
    updateOrderDataIsLoading(active) {
      this.$store.commit('updateOrderDataIsLoading', active);
    },
    updateOrderStatus(payload) {
      this.$store.commit('updateOrderStatus', payload.target.value);
    },
    updateFilterOrderByDate(payload) {
      this.$store.commit('updateFilterOrderByDate', payload.target.value);
    },
    updateFilterOrderByDateStart(payload) {
      this.$store.commit('updateFilterOrderByDateStart', payload.target.value);
    },
    updateFilterStatus(payload) {
      this.$store.commit('updateFilterOrderByStatusId', payload.target.value);
    },
    setOrderClient(payload) {
      this.$store.commit('updateCreateOrderClient', payload.id);
      this.$store.commit('updateClientFilterStr', payload.fullName);
      this.showOptions = false;
    },
    setOrderProduct(payload) {
      this.$store.commit('updateCreateOrderProduct', payload.target.value);
    },
    setSinglePrice(price) {
      this.$store.commit('updateSingleProductPrice', price);
    },
    setProductCount(count) {
      this.$store.commit('updateSingleProductQty', count);
    },
    setSelectedProductCount(count) {
      this.$store.commit('updateSelectedProductCount', Number(count));
    },
    setSingleOrderTotalPrice(totalPrice) {
      this.$store.commit('updateOrderSingleTotalPrice', totalPrice);
    },
    setCreateOrderFrom(date) {
      this.$store.commit('updateCreateOrderFrom', date.target.value);
    },
    setCreateOrderTo(date) {
      this.$store.commit('updateCreateOrderTo', date.target.value);
    },
    setDayDifference(diff) {
      this.$store.commit('updateDayDifference', diff);
    },
    setOrderDiscount(discount) {
      if (discount >= 0 && discount <= 100) {
        this.$store.commit('updateCreateOrderDiscount', discount);
      }
    },
    clearSingleProduct() {
      this.$store.commit('clearSingleCreateProduct');
    },
    setCreateProductItems(product) {
      this.$store.commit('updateCreateProductItems', product);
    },

    clearOrderFields() {
      this.$store.commit('clearOrderData');
    },
    setIsLoading(active) {
      this.$store.commit('updateIsOrderDataLoading', active);
    },
    setOrderDeposit(deposit) {
      this.$store.commit('updateOrderDeposit', Number(deposit.target.value));
    },
    setOrderShipment(shipment) {
      this.$store.commit('updateOrderShipment', Number(shipment.target.value));
    },
    setOrderAssembly(assembly) {
      this.$store.commit('updateOrderAssembly', Number(assembly.target.value));
    },
    setOrderInstallation(Installation) {
      this.$store.commit('updateOrderInstallation', Number(Installation.target.value));
    },
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      velocity(el, {opacity: 1}, {duration: 500, complete: done});
    },
    leave(el, done) {
      velocity(el, {opacity: 0}, {duration: 500, complete: done});
    },
    fullUpdate() {
      this.setIsLoading(true);
      this.fetchData();
      this.fetchClient();
      this.setIsLoading(false);
    },

  },
  mounted() {
    this.setIsLoading(true);
    this.fetchData();
    this.fetchProducts();
    this.fetchClient();
    this.setIsLoading(false);
  },
};
</script>

<style scoped>

.date-block {
  border: 1px solid #d2d6da;
  color: #495057;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
}

.input-container {
  max-width: 300px;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.order-block {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  align-items: center;
}

.input-count {
  margin-top: 10px;
  max-width: 120px;
  width: 100%;
}

.products-preview {
  margin-top: 16px;
  width: 100%;
}

td, th {
  width: auto;
  font-size: 0.8rem;
}

.row-input {
  display: flex;
  align-items: start;
}

.order-discount {
  max-width: 70px;
}

.modal {
  z-index: 1001;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.modal-product {
  z-index: 1002;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100VH;
  background-color: #00000094;
  display: flex !important;
  align-items: center;
  justify-content: center;
}

.table-container {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 5px;
}

.sub-total {
  margin-top: 8px;
  font-size: 0.8rem;
  font-weight: 600;
}

.options-list {
  position: absolute;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  padding-left: 0;
  border: 1px solid #d2d6da;
  border-radius: 0.5rem;
  background-color: white;
  z-index: 1;
  top: 100%;
  margin-top: 0.25rem;
}

.options-list li {
  padding: 0.5rem 0.5rem;
  cursor: pointer;
  list-style-type: none;
}

.options-list li:hover {
  background-color: #f8f9fa;
}

</style>
